import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dropdown",
  "use": "dropdown-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dropdown\">\n    <path fill-rule=\"evenodd\" d=\"m19.6 9.713-7.036 6.218-.124-.116-.119.116L6.1 9.63l.687-.23 5.721 5.502 5.714-5.652 1.378.463z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol